// Legacy code: Localstorage approach
// export const loadState = () => {
//   try {
//     const serializedState = localStorage.getItem("state");
//     if (serializedState === null) {
//       return undefined;
//     }
//     return JSON.parse(serializedState);
//   } catch (error) {
//     return undefined;
//   }
// };

// export const saveState = (state) => {
//   try {
//     const serializedState = JSON.stringify(state);
//     localStorage.setItem("state", serializedState);
//   } catch (error) {
//     console.log(error);
//   }
// };

// IndexedDB approach
const DB_NAME = "lumitDB";
const STORE_NAME = "stateStore";
const KEY = "reduxState";

// To open DB connection
const openDB = () =>
  new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);

    req.onupgradeneeded = (e) => {
      e.target.result.createObjectStore(STORE_NAME);
    };

    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });

// Load DB data
export const loadState = async () => {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);

    return await new Promise((resolve) => {
      const req = store.get(KEY);
      req.onsuccess = () => resolve(req.result || undefined);
      req.onerror = () => resolve(undefined);
    });
  } catch (error) {
    console.error(error);
  }
};

// Save DB data
export const saveState = async (state) => {
  openDB()
    .then((db) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);

      const cleanState = JSON.parse(
        JSON.stringify(state, (key, value) => (typeof value === "function" ? undefined : value)),
      );

      store.put(cleanState, KEY);
    })
    .catch((error) => {
      console.error(error);
    });
};

const WIDGET_STATE_STORAGE_KEY = "widgetStateById";

const readWidgetStates = () => {
  try {
    const serialized = localStorage.getItem(WIDGET_STATE_STORAGE_KEY);
    return serialized ? JSON.parse(serialized) : {};
  } catch (_error) {
    return {};
  }
};

const writeWidgetStates = (states) => {
  try {
    localStorage.setItem(WIDGET_STATE_STORAGE_KEY, JSON.stringify(states));
  } catch (error) {
    console.log(error);
  }
};

export const getWidgetState = (widgetId, widgetState = {}) => {
  if (!widgetId) return undefined;

  if (widgetState && typeof widgetState === "object" && widgetId in widgetState) {
    return widgetState[widgetId];
  }

  const persistedStates = readWidgetStates();
  return persistedStates[widgetId];
};

export const setWidgetState = (widgetId, widgetState = {}, nextState = {}) => {
  if (!widgetId) return;

  const persistedStates = readWidgetStates();
  const previousState = (widgetState && widgetState[widgetId]) || persistedStates[widgetId] || {};
  const updatedState = { ...previousState, ...nextState };

  if (widgetState && typeof widgetState === "object") {
    widgetState[widgetId] = updatedState;
  }

  persistedStates[widgetId] = updatedState;
  writeWidgetStates(persistedStates);

  return updatedState;
};

/* New Implementation for the full screen navigation */
export const breakpoints = {
  xs: [0, 539],
  sm: [540, 767],
  md: [768, 959],
  lg: [960, 1139],
  xl: [1140, 1399],
  xxl: [1400, Infinity],
};

export const SET_NAVIGATION = "set-navigation";
export const GET_NAVIGATION = "get-navigation";
export const PUSH_SUBNAVIGATION = "push-subnavigation";
export const TOGGLE_NAV = "toggle-navigation";
export const SET_SUBHEADER_COMPONENTS = "set-subheader-components";
export const DELETE_SUBHEADER_COMPONENT = "delete-subheader-component";
export const CLEAR_SUBHEADER_COMPONENTS = "clear-subheader-components";

export const toggleNavigation = (show) => ({
  type: TOGGLE_NAV,
  open: show,
});

export const setNavigation = (navigation) => ({
  type: SET_NAVIGATION,
  navigation,
});

export const getNavigation = () => ({
  type: GET_NAVIGATION,
});

export const pushSubNavigation = (subNavigation) => ({
  type: PUSH_SUBNAVIGATION,
  subNavigation,
});

export const setSubHeaderComponents = (components) => ({
  type: SET_SUBHEADER_COMPONENTS,
  components,
});

export const deleteSubHeaderComponent = (widgetId) => ({
  type: DELETE_SUBHEADER_COMPONENT,
  widgetId,
});

export const clearSubHeaderComponents = (components) => ({
  type: CLEAR_SUBHEADER_COMPONENTS,
  components,
});

export const getCacheSubNavigationById = (state, id) => {
  return state.find((subNavigation) => subNavigation.id === id);
};

export const isSubNavigationExist = (subNavigations, id) => {
  return subNavigations?.some((item) => item.id === id);
};

export const getBreakpoint = () => {
  let windowWidth = window.innerWidth;
  // let windowHeight = window.innerHeight;
  let currentBreakpoint = "lg";

  for (let key in breakpoints) {
    //console.log(key, windowWidth, breakpoints[key][0], breakpoints[key][1]);

    if (windowWidth >= breakpoints[key][0] && windowWidth <= breakpoints[key][1]) {
      currentBreakpoint = key;
    } //if
  } //for

  return currentBreakpoint;
};
